import { ComponentType, FC, useMemo } from 'react';

import {
	DBObservableDataContextProvider,
	IDBObservableDataContext,
	usePassengerBookings$,
	useSubscription$,
	useSubscriptionTickets$,
	useUser$,
} from '@mopla/business-logic';
import { wrapDisplayName } from '@mopla/utils';

export const withDBObservableDataContext = (
	WrappedComponent: ComponentType
) => {
	const Wrapper: FC = () => {
		const user$ = useUser$();
		const subscription$ = useSubscription$();
		const subscriptionTickets$ = useSubscriptionTickets$();
		const bookings$ = usePassengerBookings$();

		const ctx = useMemo<IDBObservableDataContext>(
			() => ({ user$, subscription$, subscriptionTickets$, bookings$ }),
			[user$, subscription$, subscriptionTickets$, bookings$]
		);

		return (
			<DBObservableDataContextProvider value={ctx}>
				<WrappedComponent />
			</DBObservableDataContextProvider>
		);
	};

	Wrapper.displayName = wrapDisplayName(
		WrappedComponent,
		'withDBObservableData'
	);

	return Wrapper;
};
